import type { ComponentProps } from "react";
import { cn } from "../cn";

/** Only for waits over 300 ms, shaped like the content (design-system.md §4.12). */
export function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return <div aria-hidden className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}
